module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentEvent) ? _c('div', {
    staticClass: "event-info"
  }, [_c('ul', {
    staticClass: "event-fields"
  }, [_c('li', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "event-field"
  }, [_vm._v(_vm._s(_vm.$d(_vm.clock.today, "date")))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" "), _c('span', {
    staticClass: "event-field"
  }, [_vm._v(_vm._s(_vm.$d(_vm.currentEvent.start, "hourMinute")) + " - " + _vm._s(_vm.$d(_vm.currentEvent.end, "hourMinute")))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-people"
  }), _vm._v(" "), _c('span', {
    staticClass: "event-field organizer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleAttendees()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentEvent.organizer))]), _vm._v(" "), (_vm.currentEvent.attendees.length) ? _c('span', [_c('i', {
    class: _vm.isAttendeesVisible ? 'icon-circle-right' : 'icon-circle-down'
  })]) : _vm._e()]), _vm._v(" "), (_vm.isAttendeesVisible) ? _c('div', {
    staticClass: "attendees",
    on: {
      "click": function($event) {
        _vm.toggleAttendees()
      }
    }
  }, _vm._l((this.currentEvent.attendees), function(attendee, index) {
    return _c('div', {
      key: index
    }, [_c('i', {
      staticClass: "icon-user-check"
    }), _c('span', [_vm._v(_vm._s(attendee.name))])])
  })) : _vm._e()])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-bullet"
  }), _vm._v(" "), _c('span', {
    staticClass: "event-field subject"
  }, [_vm._v(_vm._s(_vm.currentEvent.subject))])])]), _vm._v(" "), _c('div', {
    staticClass: "event-bottom"
  }, [_c('div', {
    staticClass: "bottom-left"
  }, [_vm._v("Vapautuu")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-right"
  }, [_vm._v(_vm._s(_vm.$d(_vm.eventStatus.seriesEnd, "hourMinute")))])])]) : _c('div', {
    staticClass: "event-info"
  }, [_c('ul', {
    staticClass: "event-fields"
  }, [_c('li', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$d(_vm.clock.today, "date")))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" "), (_vm.eventStatus.nextEvent) ? _c('span', [_vm._v("Vapaa " + _vm._s(_vm.$d(_vm.eventStatus.nextEvent.start, "hourMinute")) + " asti")]) : _c('span', [_vm._v("Vapaa loppupäivän")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-bullet"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f381835","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/OtEventInfo.vue
// module id = 238
// module chunks = 0